/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import './CruiseDetails.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getContentWithRoute } from '../../../api/loginApi';
import CruiseCheckoutForm from '../CruiseCheckoutForm';
import { useAppContext } from '../../../saas/AppConfigWrapper';

function CruiseDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [trip, setTrip] = useState(null);
  const [allTrips, setAllTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openIndex, setOpenIndex] = useState(null);
  const [selectedTripCode, setSelectedTripCode] = useState(null);
  const [showCheckoutForm, setShowCheckoutForm] = useState(false);
  const [genders, setGenders] = useState({});
  const [genderErrors, setGenderErrors] = useState({});

  const [bookings, setBookings] = useState({});
  const [totalFare, setTotalFare] = useState(0);
  const [showBookingPopup, setShowBookingPopup] = useState(false);
  const { appConfig } = useAppContext();

  const photos = [
    'https://storage.googleapis.com/oceanwide_web/media/default/0001/16/497a186012ba40d6bbe20bcbb3e718f7fb8d491a.jpeg',
    'https://storage.googleapis.com/oceanwide_web/media/default/0001/16/917c2f6a386ef268ff9b70e88360be43d8171dbc.jpeg',
  ];

  useEffect(() => {
    const fetchTrip = async () => {
      try {
        const response = await getContentWithRoute(
          'trip-feed/agents?currency=USD',
        );
        const data = await response;
        setAllTrips(data.trips);

        const matchedTrip = data.trips.find(
          (t) => t.url.split('/').pop() === slug,
        );
        if (matchedTrip) {
          setTrip(matchedTrip);
          setSelectedTripCode(matchedTrip.code);
        } else {
          setError('Trip not found');
        }
      } catch (err) {
        setError('Failed to load trip details');
      } finally {
        setLoading(false);
      }
    };

    fetchTrip();
  }, [slug]);

  if (loading) return <p className="loading">Loading trip details...</p>;
  if (error) return <p className="error">{error}</p>;

  const tabTrips = [
    trip,
    ...(trip.combination_trips
      ? allTrips.filter((t) => trip.combination_trips.includes(t.id))
      : []),
  ];

  const selectedTrip =
    tabTrips.find((t) => t.code === selectedTripCode) || trip;

  const handleBook = (tripCode, cabin) => {
    setBookings((prev) => {
      const updated = { ...prev, [tripCode]: cabin };

      if (Object.keys(updated).length === tabTrips.length) {
        const fare = Object.values(updated).reduce(
          (sum, c) => sum + Number(c.price || 0),
          0,
        );
        setTotalFare(fare);
        setShowBookingPopup(true); // All combo trips booked, show popup
      } else {
        toast.info('Please book for all combination trips to checkout');
      }

      return updated;
    });
  };

  const handleCheckout = () => {
    const selectedCabins = bookings;
    navigate('/checkout', { state: { selectedCabins, totalFare } }); // Show the checkout form instead of navigating
  };

  return (
    <div className="cruise-details">
      {/* Title Section */}
      <div className="image-wrapper">
        <img src={photos[0]} alt="Cruise map" className="cruise-image" />
        <div className="title-section">
          <h1>{trip.name}</h1>
          <p>
            {trip.departure_date} – {trip.return_date}
          </p>
          {trip.only_in_combination && (
            <div className="combination-notice">
              This cruise can only be booked in combination with another.
            </div>
          )}
        </div>
      </div>

      {/* Map & Info */}
      <div className="map-info">
        <div className="map-wrapper">
          <img src={trip.map} alt="Cruise map" className="map-image" />
        </div>
        <div className="info-text">
          <div>
            <strong>Trip Code:</strong> {trip.code}
          </div>
          <div>
            <strong>Ship:</strong> {trip.ship}
          </div>
          <div>
            <strong>Embark - Disembark:</strong> {trip.embark} -{' '}
            {trip.disembark}
          </div>
          <div>
            <strong>Duration:</strong> {trip.nights} nights / {trip.days} days
          </div>
          <div>
            <strong>Language:</strong> English
          </div>
        </div>
      </div>

      {trip.please_note && (
        <div
          className="note-section"
          dangerouslySetInnerHTML={{ __html: trip.please_note }}
        />
      )}

      <div className="summary-section">
        <h2>Short Description</h2>
        <div
          className="summary-content"
          dangerouslySetInnerHTML={{ __html: trip.summary }}
        />
      </div>

      {trip.itineraries?.length > 0 && (
        <div className="itinerary-section">
          <h2>Itinerary</h2>
          <div className="itinerary-list">
            {trip.itineraries.map((item, index) => (
              <div key={index} className="itinerary-item">
                <div className="itinerary-header">
                  <div className="itinerary-title flex items-start gap-2">
                    <h3
                      onClick={() =>
                        setOpenIndex(openIndex === index ? null : index)
                      }
                    >
                      {item.day}
                      {item.title ? `: ${item.title}` : ''}
                    </h3>
                    {item.port && <p className="itinerary-port">{item.port}</p>}
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="itinerary-summary"
                    dangerouslySetInnerHTML={{ __html: item.summary }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      <ToastContainer position="top-center" />
      {trip.combination_trips?.length > 0 && (
        <div className="mb-4">
          <h3
            className="text-lg font-bold text-orange-600 mb-2 mt-2"
            style={{ color: 'orange' }}
          >
            Combination Trips
          </h3>
          <div className="map-info">
            {allTrips
              .filter((t) => trip.combination_trips.includes(t.id))
              .map((comboTrip, index) => (
                <div key={comboTrip.id} className="map-wrapper">
                  <Link
                    to={`/cruise/${comboTrip.url.split('/').pop()}`}
                    style={{
                      display: 'flex',
                      textDecoration: 'none',
                      color: 'inherit',
                    }}
                  >
                    <img
                      src={photos[index % photos.length]}
                      alt={`${comboTrip.name} photo`}
                      style={{
                        width: '300px',
                        height: '250px',
                        marginRight: '5px',
                      }}
                    />
                    <div className="md:w-2/3 p-2 bg-white rounded">
                      <h4 className="text-sm font-semibold text-blue-800 mb-1">
                        {comboTrip.name}
                      </h4>
                      <p
                        className="text-xs text-gray-600"
                        dangerouslySetInnerHTML={{ __html: comboTrip.summary }}
                      />
                    </div>
                  </Link>
                </div>
              ))}
          </div>
        </div>
      )}

      {tabTrips.length > 0 && (
        <div>
          <h2 className="summary-section">Cabins & Prices</h2>

          <div
            style={{
              display: 'flex',
              borderBottom: '1px solid #ccc',
              marginBottom: '1rem',
              cursor: 'pointer',
            }}
          >
            {tabTrips.map((t) => (
              <div
                key={t.id}
                onClick={() => setSelectedTripCode(t.code)}
                style={{
                  padding: '10px 15px',
                  borderBottom:
                    selectedTripCode === t.code ? '3px solid orange' : 'none',
                  fontWeight: selectedTripCode === t.code ? 'bold' : 'normal',
                  color: selectedTripCode === t.code ? 'orange' : 'black',
                }}
              >
                {t.code}
              </div>
            ))}
          </div>

          <div className="fs-14 bg-white border border-orange-200 p-4 rounded-b space-y-6">
            <p className="text-m text-gray-600" style={{ color: 'orange' }}>
              Prices are displayed with discounts applied if you book berths or
              cabins on all cruises.
            </p>
            <div className="map-info">
              {selectedTrip.cabins?.map((cabin, index) => (
                <div key={index} className="map-wrapper">
                  <div className="image-container">
                    <img
                      src={`/images/others/${cabin.title}.jpg`}
                      alt={`${cabin.title} cabin`}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                      onError={(e) => (e.target.style.display = 'none')}
                    />
                  </div>
                  <div className="content-container">
                    <strong>
                      <p className="text-xl font-bold fs-14 text-blue-800">
                        {cabin.title}
                      </p>
                    </strong>
                    <div className="text-sm text-gray-700 mt-1">
                      {cabin.discount ? (
                        <p>
                          <span className="line-through text-red-500">
                            ${cabin.old_price}
                          </span>{' '}
                          <span className="text-green-600 font-semibold">
                            ${cabin.price}
                          </span>{' '}
                          <span className="text-xs text-gray-500">
                            (You save ${cabin.discount})
                          </span>
                        </p>
                      ) : (
                        <p className="text-gray-800">${cabin.price}</p>
                      )}

                      <div className="mt-2">
                        <label
                          htmlFor={`gender-${index}`}
                          className="block mb-1 text-gray-700"
                        >
                          Select Gender:
                        </label>
                        <select
                          id={`gender-${index}`}
                          name={`gender-${index}`}
                          className="border border-gray-300 rounded px-2 py-1 text-sm"
                          value={genders[index] || ''}
                          onChange={(e) => {
                            const { value } = e.target;
                            setGenders((prev) => ({ ...prev, [index]: value }));
                            setGenderErrors((prev) => ({
                              ...prev,
                              [index]: '',
                            })); // clear error on change
                          }}
                        >
                          <option value="">-- Select --</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>

                        {genderErrors[index] && (
                          <p
                            className="text-red-600 text-sm mt-1"
                            style={{ color: 'red' }}
                          >
                            {genderErrors[index]}
                          </p>
                        )}
                      </div>

                      <button
                        style={{
                          backgroundColor: 'orange',
                          color: 'white',
                          border: 'none',
                          width: '80px',
                          height: '40px',
                          fontSize: '16px',
                        }}
                        className={`mt-2 px-1 py-1 rounded text-green ${
                          bookings[selectedTripCode]?.title === cabin.title
                            ? 'bg-green-600'
                            : 'bg-blue-600'
                        }`}
                        onClick={() => {
                          if (!genders[index]) {
                            setGenderErrors((prev) => ({
                              ...prev,
                              [index]: 'Please select gender',
                            }));
                            return;
                          }

                          setGenderErrors((prev) => ({ ...prev, [index]: '' }));

                          // Call your booking function
                          handleBook(selectedTripCode, cabin);
                        }}
                      >
                        {bookings[selectedTripCode]?.title === cabin.title
                          ? 'Booked'
                          : 'Book'}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Booking Popup Modal */}
      {showBookingPopup && (
        <div
          className="booking-popup-backdrop"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={() => setShowBookingPopup(false)} // close on backdrop click
        >
          <div
            className="booking-popup"
            style={{
              background: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '400px',
              maxHeight: '80vh',
              overflowY: 'auto',
            }}
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            <h3 style={{ marginBottom: '1rem', color: 'orange' }}>
              Bookings Summary
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, marginBottom: '1rem' }}>
              {Object.entries(bookings).map(([tripCode, cabin]) => (
                <li
                  key={tripCode}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '0.5rem',
                  }}
                >
                  <span>{tripCode}</span>
                  <span>${cabin.price}</span>
                </li>
              ))}
            </ul>
            <hr />
            <div
              style={{
                marginTop: '1rem',
                display: 'flex',
                justifyContent: 'space-between',
                fontWeight: 'bold',
              }}
            >
              <span>Total Fare:</span>
              <span>${totalFare}</span>
            </div>
            <button
              onClick={handleCheckout}
              style={{
                marginTop: '1.5rem',
                padding: '10px 15px',
                width: '100%',
                backgroundColor: 'orange',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: '5px',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Checkout
            </button>
          </div>
        </div>
      )}
      {showCheckoutForm && selectedTrip && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-2xl relative">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
              onClick={() => setShowCheckoutForm(false)}
            >
              &times;
            </button>

            <h1 className="text-2xl font-bold mb-2">Passenger Information</h1>
            <p className="text-sm text-gray-600 mb-4">
              Trip Code:{' '}
              <span className="font-semibold">{selectedTrip.code}</span> | Fare:
              ₹{selectedTrip.price}
            </p>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm">Title</label>
                <select className="w-full border px-2 py-1 rounded">
                  <option>Mr.</option>
                  <option>Ms.</option>
                  <option>Mrs.</option>
                </select>
              </div>
              <div>
                <label className="block text-sm">First name *</label>
                <input className="w-full border px-2 py-1 rounded" />
              </div>
              <div>
                <label className="block text-sm">Last name *</label>
                <input className="w-full border px-2 py-1 rounded" />
              </div>
              <div>
                <label className="block text-sm">Date of birth *</label>
                <input
                  type="date"
                  className="w-full border px-2 py-1 rounded"
                />
              </div>
              <div>
                <label className="block text-sm">Nationality *</label>
                <select className="w-full border px-2 py-1 rounded">
                  <option>India</option>
                  <option>USA</option>
                  <option>UK</option>
                </select>
              </div>
              <div>
                <label className="block text-sm">Email address *</label>
                <input
                  type="email"
                  className="w-full border px-2 py-1 rounded"
                />
              </div>
              <div>
                <label className="block text-sm">Phone number *</label>
                <input
                  type="tel"
                  className="w-full border px-2 py-1 rounded"
                  defaultValue={appConfig.appMobileCode}
                />
              </div>
            </div>

            <button
              className="mt-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded w-full"
              onClick={() => {
                // Handle form submission here
                setShowCheckoutForm(false);
              }}
            >
              Confirm & Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CruiseDetails;
